import React from "react";
import Property from "../features/property/component/Property";
import Footer from "./Footer";
// import PropertyTest from "../features/property/component/PropertyTest";

function PropertyPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <Property />
      {/* <PropertyTest /> */}
      <Footer />
    </div>
  );
}

export default PropertyPage;
